import colors from '@service-victoria/component-library/utils/colors';
import React from 'react';
import styled from 'styled-components';

type SummaryItemProps = {
  children?: never;
  value: string | boolean;
  label: string;
};

const Label = styled.dt`
  font-weight: 600;
  font-family: 'VIC';
  line-height: 24px;
  margin: 0 0 8px;
  color: ${colors.blueGrey};
`;

const Value = styled.dd`
  display: block;
  margin: 0 0 24px;
  color: ${colors.blueGrey};
`;

const SummaryItem: React.FC<SummaryItemProps> = ({ value, label }) => (
  <>
    <Label>{label}</Label>
    <Value>{typeof value === 'boolean' ? (value ? 'Yes' : 'No') : value}</Value>
  </>
);

export default SummaryItem;
